function toJobItemTypeFormatter(value: any, defaultValue: string | undefined) {

  let def: string = '???';
  if (defaultValue !== undefined) {
    def = defaultValue;
  }
  if (value !== null && value !== undefined) {
    // Underground = 1,
    // Overhead = 2,
    // Drafting = 4,
    // Detailing = 8,
    // ProjectManagement = 16,
    // Design = 32,
    // Undergound Location = 64,

    switch (value) {
      case 1:
        return 'Underground';
        break;

      case 2:
        return 'Overhead';
        break;

      case 4:
        return 'Drafting';
        break;

      case 8:
        return 'Detailing';
        break;

      case 16:
        return 'Project Management';
        break;

      case 32:
        return 'Design';
        break;

      case 64:
        return 'Undergound Location';
        break;

      case 128:
        return 'Administration';
        break;
    
      default:
        console.log('Unknown job type:', value);
        return def;
        break;
    }
    
  } else {
    console.log('Invalid job type:', value);
    return def;
  }
}

export default toJobItemTypeFormatter;
